import { utils, write } from "xlsx";
import { saveAs } from "file-saver";

/**
 * Exporta datos seleccionados a Excel.
 *
 * @param {string} fileName - Nombre del archivo sin extensión.
 * @param {Array} allColumns - Todas las columnas originales (de MUI DataTable).
 * @param {Array} values - Filas con estructura `data` como en MUI DataTable.
 * @param {Array<string>} columnLabelsToExport - Lista de etiquetas (labels) de columnas a exportar.
 */
export const exportToExcel = (
  fileName,
  allColumns,
  values,
  columnLabelsToExport
) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  // Identificar índices de columnas que se deben exportar
  const columnIndexesToExport = allColumns
    .map((col, idx) => (columnLabelsToExport.includes(col.label) ? idx : -1))
    .filter((idx) => idx !== -1);

  // Construir JSON con solo las columnas deseadas
  const json = values.map((row) => {
    const obj = {};
    columnIndexesToExport.forEach((idx) => {
      const label = allColumns[idx].label;
      obj[label] = row.data[idx];
    });
    return obj;
  });

  const ws = utils.json_to_sheet(json);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });

  saveAs(data, `${fileName}${fileExtension}`);
};

/**
 * Exporta datos JSON directamente a Excel.
 *
 * @param {string} fileName - Nombre del archivo sin extensión.
 * @param {Array} jsonData - Array de objetos JSON a exportar.
 * @param {number} columnWidth - Ancho opcional para todas las columnas (por defecto 22).
 */
export const exportJsonToExcel = (fileName, jsonData, columnWidth = 22) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const ws = utils.json_to_sheet(jsonData);

  if (jsonData.length > 0) {
    const headers = Object.keys(jsonData[0]);
    ws["!cols"] = headers.map(() => ({ wch: columnWidth }));
  }

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });

  saveAs(data, `${fileName}${fileExtension}`);
};
